export { getCookie } from "./getCookie";
export { scrollAnimate } from "./scrollAnimate";
export { scrollToElement } from "./scrollToElement";
export { handleDefaultModal } from "./handleDefaultModal";
export { isVisibleFormModal } from "./isVisibleFormModal";